import axios from "axios";
const baseurl = process.env.REACT_APP_API_URL;

export const getInstructions = async () => {
  const res = await axios({
    method: "get",
    url: baseurl + `/getInstruction`,
  });
  return res.data.data;
};
